import apiBase from './ApiBase'

class ApiService {
  getCovidRestrictions = data => apiBase.get('/api/CovidApi/GetCovidRestrictions')
}

const MedAireSecurityAPIService = new ApiService()

export default MedAireSecurityAPIService